import * as React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Image, ArrowRight } from 'lucide-react';
const galleryItems = [{
  id: 1,
  title: "The Obsidian Residence",
  service: "Architectural Design",
  image: "https://fivestarsroofline.com/wp-content/uploads/2026/03/626529845_1495323095927454_6784815751320281840_n-1-2.jpg?v=plugctdjhnb"
}, {
  id: 2,
  title: "Azure Coast Pavilion",
  service: "New Construction",
  image: "https://fivestarsroofline.com/wp-content/uploads/2026/03/650361835_1527646639361766_6457712949298865254_n.jpg?v=s3s9dj7n2q9"
}, {
  id: 3,
  title: "Ethereal Loft Gallery",
  service: "Interior Curation",
  image: "https://fivestarsroofline.com/wp-content/uploads/2026/03/628167656_1495323045927459_6891382986973396176_n-1.jpg?v=fknhnk3lia"
}, {
  id: 4,
  title: "Monolith Corporate HQ",
  service: "Commercial Design",
  image: "https://fivestarsroofline.com/wp-content/uploads/2026/03/637701234_1508805021245928_3889829010141165144_n.jpg?v=s5b9w8gyp8h"
}, {
  id: 5,
  title: "Heritage Stone Manor",
  service: "Restoration",
  image: "https://fivestarsroofline.com/wp-content/uploads/2026/03/628287559_1495322992594131_8742454672351491984_n.jpg?v=qchzc5pw31"
}, {
  id: 6,
  title: "Skyline Penthouse",
  service: "Modern Renovation",
  image: "https://fivestarsroofline.com/wp-content/uploads/2026/03/638316596_1508805077912589_6049308714775291104_n.jpg?v=zy6n10p58zo"
}];
export default function ProjectPhotoGallery() {
  return <section data-section-id="130715" id="recent-projects-gallery" className="py-20 md:py-28 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-12 md:mb-16">
          <div className="inline-flex items-center justify-center p-2 bg-primary/10 rounded-full mb-4">
            <Image className="w-5 h-5 text-primary" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground tracking-tight mb-4">Recent Projects</h2>
          <p className="text-lg text-muted-foreground max-w-2xl font-sans">
            Explore our portfolio of bespoke residences and commercial transformations, where precision meets visionary design.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {galleryItems.map((item, i) => <Card key={item.id} data-index={i} className="group overflow-hidden border-white/10 bg-card hover:shadow-2xl transition-all duration-500 rounded-none">
              <CardContent className="p-0 relative aspect-[4/3] overflow-hidden">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-0 group-hover:opacity-100 backdrop-blur-[2px] transition-all duration-500 flex flex-col justify-end p-6 translate-y-4 group-hover:translate-y-0">
                  <span className="text-primary text-xs font-sans font-bold mb-2 uppercase tracking-widest">
                    {item.service}
                  </span>
                  <h3 className="text-white text-2xl font-serif mb-4">
                    {item.title}
                  </h3>
                  <div className="inline-flex items-center text-white text-sm font-sans font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-700 delay-100">
                    View Details
                    <ArrowRight className="ml-2 w-4 h-4" />
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-16 flex justify-center">
          <Link to="/ServicesPage">
            
          </Link>
        </div>
      </div>
    </section>;
}